<ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name="meliitemcontainerterms">
</ngx-spinner>
<div class="content">
    <div class="attrib-grid">
        <ng-container *ngFor="let data of terms" [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:data, type:'A'}"></ng-container>
    </div>
</div>
<div class="actions">
  <div class="search-actions">
    <input nz-input (keyup)="updateFilter($event)" [placeholder]="'meli.garantia.search'|translateTA" />
  </div>
  <span class="spacer"></span>
  <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>


<ng-template #main let-item let-type="type">
  <div class="attrib-card" [class.attrib-card-required]="isRequired(item,type)">
    <div class="attrib-card-header">
      <span class="attrib-card-title" nz-tooltip [nzTooltipTitle]="item.name == null || item.name == undefined ? item.descratrib : item.name">
        {{item.name == null || item.name == undefined ? item.descratrib : item.name}}
      </span>
      <nz-icon nzType="warning" class="attrib-card-warn" *ngIf="checkAtribVar(item)"
          nz-tooltip [nzTooltipTitle]="'meli.form.attribVariationWarning'|translateTA" />
      <span class="spacer"></span>
      <nz-icon nzType="close" class="attrib-card-close" (click)="deleteItem(item,type)" *ngIf="!isRequired(item,type)" />
    </div>
    <div class="attrib-card-hint" nz-tooltip [nzTooltipTitle]="item.hint">{{item.hint}}</div>

    <div class="attrib-card-content">
      <!-- Texto -->
      <nz-input-group [nzSuffix]="suffixInfo" *ngIf="item.value_type=='string' || item.value_type==null" class="full">
          <input nz-input type="text" [maxLength]="item.value_max_length == null? 500 : item.value_max_length"
              [(ngModel)]="item.value_id" [required]="isRequired(item,type)" [CustomValidatorDirective]="attribValidator"
              [placeholder]="item.example" (ngModelChangeDebounced)="onModelChange(item)" />
      </nz-input-group>

      <!-- Numero + unidade -->
      <div *ngIf="item.value_type=='number_unit'" class="multi-field">
        <nz-input-group [nzSuffix]="suffixProduct" *ngIf="item.value_type=='number_unit'" class="left">
            <input nz-input type="number" [maxLength]="item.value_max_length == null? 500 : item.value_max_length"
                [required]="isRequired(item,type)" [(ngModel)]="item.value_id" (blur)="onBlur(item,type)"
                [CustomValidatorDirective]="attribValidator" [placeholder]="item.example"
                (ngModelChangeDebounced)="onModelChange(item)" />
        </nz-input-group>
        <nz-select class="right" [required]="isRequired(item,type)" (nzBlur)="onBlur(item,type)" [(ngModel)]="item.value_unit"
            [CustomValidatorDirective]="attribValidator" (ngModelChangeDebounced)="onModelChange(item)"
            nzAllowClear [nzPlaceHolder]="'meli.form.unit'|translateTA">
            <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.allowed_units"></nz-option>
        </nz-select>
      </div>

      <!-- Numero -->
      <nz-input-group [nzSuffix]="suffixProduct" *ngIf="item.value_type=='number'" class="full">
        <input nz-input type="number" [maxLength]="item.value_max_length" [(ngModel)]="item.value_id"
            [required]="isRequired(item,type)" (blur)="onBlur(item,type)" [CustomValidatorDirective]="attribValidator"
            [placeholder]="item.example" (ngModelChangeDebounced)="onModelChange(item)" />
      </nz-input-group>

      <!-- Lista/boolean/string com opcoes -->
      <nz-select *ngIf="(item.value_type=='boolean' || item.value_type=='list' || ( item.value_type == 'string' && item.values != null ) )"
          class="full" [required]="isRequired(item,type)" [(ngModel)]="item.value_id" (nzBlur)="onBlur(item,type)"
          [CustomValidatorDirective]="attribValidator" (ngModelChangeDebounced)="onModelChange(item)"
          nzShowSearch nzAllowClear [nzPlaceHolder]="item.name == null || item.name == undefined ? item.descratrib : item.name">
        <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.values"></nz-option>
      </nz-select>

      <ng-template #suffixInfo>
        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.garantia.fetchInfo'|translateTA"
            (click)="openDataOption(item)" />
        <nz-icon nzType="close-circle" class="field-action" *ngIf="value" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
            (click)="value=''" />
      </ng-template>
      <ng-template #suffixProduct>
        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
            (click)="openDataOption(item)" />
        <nz-icon nzType="close-circle" class="field-action" *ngIf="value" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
            (click)="value=''" />
      </ng-template>
    </div>
  </div>
</ng-template>
